'use strict';
define([], function () {
    function SigninFeedbearController($scope, AuthService, $window) {
        AuthService.signinFeedbear()
            .then(function (res) {
                $window.location.href = res.redirectUrl;
            }).catch(function (err) {
                console.log(err);
            });

    }
    SigninFeedbearController.$inject = ['$scope', 'AuthService', '$window'];
    return SigninFeedbearController;
});
